import { FormControl, FormGroup } from '@angular/forms';
import { ICreateBeegoAppointment } from '@internal-models/beego-appointment.model';
import { IClient } from '@internal-models/client.model';
import { DigibankObjective } from '@shared-libs/enums';
import { SharedFormValidators } from '@shared-libs/form-validators';
import { IFormGroup } from '@shared-libs/interfaces';
import { IAddress } from '@shared-models/address.model';
import { ICalendarEvent } from '@shared-models/calendar-event.model';
import { ClientFormFactory } from './client-form.factory';
import { CommunicationFormFactory } from './communication-form.factory';

export class BeegoAppointmentFormFactory {
	public static create(calendarEvent: ICalendarEvent, Address: IAddress): IFormGroup<ICreateBeegoAppointment> {
		return new FormGroup({
			question: new FormControl(null, [SharedFormValidators.required]),
			replyTo: new FormControl(null, [SharedFormValidators.email]),
			telephone: new FormControl(null, [SharedFormValidators.phone]),
			Client: ClientFormFactory.createForBeegoAppointment(Address ? ({ Address: Address } as IClient) : null),
			Digicheques: new FormControl([]),
			CalendarEvent: new FormControl(calendarEvent),
			Communication: CommunicationFormFactory.create(),
			digibankObjective: new FormControl(DigibankObjective.EssentialService, [SharedFormValidators.required]),
			Attendance: new FormGroup({
				QuestionCategories: new FormControl([], [SharedFormValidators.required]),
			}),
		}) as IFormGroup;
	}

	public static getValue(form: IFormGroup<ICreateBeegoAppointment>): ICreateBeegoAppointment {
		return {
			...form.value,
			Client: ClientFormFactory.getValue(form.get('Client') as IFormGroup),
		};
	}
}
